import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get } from 'lodash-es';
import { Link } from 'site-modules/shared/components/link/link';

export function TopLink({
  className = null,
  link: { title, 'link-url': linkUrl, nofollow, img, newTab },
  tracking = null,
}) {
  if (!title || !linkUrl) {
    return null;
  }

  let rel = nofollow ? 'nofollow' : undefined;
  if (newTab) {
    rel = 'noopener noreferrer';
  }

  const trackingId = get(tracking, 'id', {});
  const trackingValue = get(tracking, 'value', {});

  return (
    <Link
      to={linkUrl}
      className={classnames('top-link d-inline-block text-primary-darker mt-1 me-lg-1_5', className)}
      data-tracking-id={trackingId[title] || trackingId.all}
      data-tracking-value={trackingValue[title]}
      rel={rel}
      target={newTab ? '_blank' : undefined}
    >
      {title}
      {!!img && <img src={img} alt={title} height={26} className="ms-0_25" />}
    </Link>
  );
}

TopLink.propTypes = {
  link: PropTypes.shape({
    title: PropTypes.string,
    'link-url': PropTypes.string,
    nofollow: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    img: PropTypes.string,
    newTab: PropTypes.bool,
  }).isRequired,
  className: PropTypes.string,
  tracking: PropTypes.shape({
    id: PropTypes.objectOf(PropTypes.string),
    value: PropTypes.objectOf(PropTypes.string),
  }),
};
